import React from "react";
import { Form, Input, InputNumber, Button, Typography, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { EQUIPMENT_TYPES } from "constants/insurance";
import { validatePieceCount } from "utils/insurance-validators";

const { Title } = Typography;

const MAX_ROWS_PER_TYPE = 5;

/**
 * Piece count validator rule for Ant Design Form.Item.
 * Only validates when a value is entered (equipment is optional).
 */
const pieceCountRule = {
  validator: (_, value) => {
    if (value === null || value === undefined || value === "") {
      return Promise.resolve();
    }
    if (validatePieceCount(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("กรุณากรอกจำนวน 1-99"));
  },
};

/**
 * EquipmentSection component for the Insurance Application Form.
 * Renders equipment entry rows for each equipment type with support
 * for adding up to 5 rows per type.
 *
 * This component is used inside a parent Ant Design Form and does not
 * wrap itself with a Form element.
 */
export default function EquipmentSection() {
  return (
    <div>
      <Title level={4}>อุปกรณ์การเล่นกอล์ฟ (Golf Equipment)</Title>

      {EQUIPMENT_TYPES.map((type, typeIndex) => (
        <Card
          key={type.value}
          size="small"
          title={type.label}
          style={{ marginBottom: 12 }}
        >
          <Form.List name={["equipment", type.value]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map((field) => (
                  <div
                    key={field.key}
                    style={{
                      display: "flex",
                      gap: 8,
                      marginBottom: 8,
                      alignItems: "flex-start",
                    }}
                  >
                    <Form.Item
                      {...field}
                      name={[field.name, "pieceCount"]}
                      rules={[pieceCountRule]}
                      style={{ flex: 1, marginBottom: 0 }}
                    >
                      <InputNumber
                        placeholder="จำนวน (1-99)"
                        min={1}
                        max={99}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>

                    <Form.Item
                      {...field}
                      name={[field.name, "identification"]}
                      rules={[{ max: 50, message: "สูงสุด 50 ตัวอักษร" }]}
                      style={{ flex: 2, marginBottom: 0 }}
                    >
                      <Input placeholder="หมายเลข/รหัส (max 50)" maxLength={50} />
                    </Form.Item>

                    <Form.Item
                      {...field}
                      name={[field.name, "brand"]}
                      rules={[{ max: 100, message: "สูงสุด 100 ตัวอักษร" }]}
                      style={{ flex: 2, marginBottom: 0 }}
                    >
                      <Input placeholder="ยี่ห้อ (max 100)" maxLength={100} />
                    </Form.Item>

                    <Button
                      type="link"
                      danger
                      onClick={() => remove(field.name)}
                      style={{ padding: "4px 8px" }}
                    >
                      ลบ
                    </Button>
                  </div>
                ))}

                {fields.length < MAX_ROWS_PER_TYPE && (
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    size="small"
                  >
                    เพิ่มรายการ
                  </Button>
                )}
              </>
            )}
          </Form.List>
        </Card>
      ))}
    </div>
  );
}
